import NewOrderBaseModel from "../new.order.base.model";

function create(m) {
  return Object.freeze(new NewOrderBaseModel(m));
}

export default { create };
